/**
 * MobilePageShell — single source of truth for full-page wrappers.
 * Enforces Contract §1:
 *
 *   • min-height: 100dvh (NOT 100vh)
 *   • no horizontal overflow
 *   • safe-area top padding
 *   • optional bottom-nav clearance — `bottomNavOffset`:
 *       "learner"     → pb-safe-24 (clears LearnerBottomNav)
 *       "instructor"  → pb-safe-24 (clears InstructorBottomNav)
 *       "none"        → pb-safe   (just home indicator)
 *   • Header-aware: when FounderModeBanner is mounted, page shells
 *     automatically share viewport via the existing
 *     `body.fmb-mounted` body class (added on banner mount).
 *
 * Banned anti-patterns this primitive REPLACES:
 *   min-h-screen · h-screen · 100vh · arbitrary pb-20/24/28 spacers
 *
 * Phase 1 — Mobile Shell programme. May 14, 2026.
 */

const OFFSET_MAP = {
  none: "pb-safe",
  learner: "pb-[calc(env(safe-area-inset-bottom,0px)+6rem)]",
  instructor: "pb-[calc(env(safe-area-inset-bottom,0px)+6rem)]",
};

export function MobilePageShell({
  children,
  bottomNavOffset = "none",
  testid,
  className = "",
  noOverflowX = true,
  ...rest
}) {
  const offset = OFFSET_MAP[bottomNavOffset] || OFFSET_MAP.none;
  return (
    <div
      data-testid={testid}
      data-mobile-shell="true"
      data-bottom-nav-offset={bottomNavOffset}
      className={[
        "min-h-dvh",                 // Contract §1 — 100dvh, never 100vh
        "pt-safe",                   // notch / safe-area top
        offset,
        noOverflowX ? "no-overflow-x" : "",
        className,
      ].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </div>
  );
}

export default MobilePageShell;
